// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardPage_earnPage__vIIYf {
    min-height: 100vh;
    background-color: #040404;
    color: #ffffff;
  }
  
  .DashboardPage_container__JcdmW {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
  }
  
  /* Dashboard Styles */
  .DashboardPage_dashboardSection__wdmsQ {
    background: #1a1a1a;
    border-radius: 12px;
    padding: 32px;
    margin-bottom: 40px;
    text-align: left;
  }
  
  .DashboardPage_statsGrid__wLNk7 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 24px;
    margin-bottom: 40px;
  }
  
  .DashboardPage_statCard__3jzJo {
    background: #2a2a2a;
    padding: 24px;
    border-radius: 8px;
    text-align: center;
  }
  
  .DashboardPage_statCard__3jzJo h3 {
    color: #666;
    margin-bottom: 12px;
    font-size: 14px;
  }
  
  .DashboardPage_statValue__draDP {
    font-size: 24px;
    font-weight: 600;
  }
  
  .DashboardPage_activityFeed__u1p8U {
    background: #2a2a2a;
    padding: 24px;
    border-radius: 8px;
  }
  
  .DashboardPage_activityFeed__u1p8U h3 {
    margin-bottom: 20px;
    color: #ffffff;
  }
  
  .DashboardPage_noActivity__1CcN1 {
    color: #666;
    text-align: center;
    padding: 20px;
  }
  
  /* Tabs Section */
  .DashboardPage_tabsSection__TXd40 {
    border-radius: 12px;
    overflow: hidden;
  }
  
  .DashboardPage_tabs__EzM93 {
    display: flex;
    border-bottom: 1px solid #2a2a2a;
  }
  
  .DashboardPage_tab__3COSE {
    padding: 12px 24px;
    background: none;
    border: none;
    color: #666;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-bottom: 2px solid transparent;
  }
  
  .DashboardPage_tab__3COSE:hover {
    color: #ffffff;
  }
  
  .DashboardPage_tab__3COSE.DashboardPage_active__wCWNZ {
    color: #ffffff;
    border-bottom-color: #ffffff;
    background: none;
  }
  
  .DashboardPage_content__dx8HA {
    padding-top: 16px;
  }
  
  /* Referral Styles */
  .DashboardPage_referralCard__PppD9 {
    background: #2a2a2a;
    padding: 24px;
    border-radius: 8px;
    margin-bottom: 24px;
  }
  
  .DashboardPage_referralInfo__zubs5 {
    margin-bottom: 20px;
    color: #666;
  }
  
  .DashboardPage_referralLinkBox__oMCMm {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
  }
  
  .DashboardPage_referralInput__8ldZu {
    flex: 1 1;
    padding: 12px 16px;
    background: #1a1a1a;
    border: 1px solid #333;
    border-radius: 4px;
    color: #ffffff;
    font-family: monospace;
    font-size: 14px;
  }
  
  .DashboardPage_referralInput__8ldZu:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .DashboardPage_copyButton__rsF2d {
    padding: 0 24px;
    background: #ffffff;
    color: #000000;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s ease;
  }
  
  .DashboardPage_copyButton__rsF2d:hover:not(:disabled) {
    opacity: 0.9;
  }
  
  .DashboardPage_copyButton__rsF2d:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .DashboardPage_copyButton__rsF2d.DashboardPage_copied__uGb0o {
    background: #4CAF50;
    color: #ffffff;
  }
  
  .DashboardPage_warning__-QjE2 {
    color: #ff4444;
    font-size: 14px;
    margin-top: 12px;
    text-align: center;
  }
  
  .DashboardPage_referralStats__Q7rlg {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 24px;
  }
  
  .DashboardPage_referralStat__JZPWi {
    background: #2a2a2a;
    padding: 24px;
    border-radius: 8px;
    text-align: center;
  }
  
  .DashboardPage_referralStat__JZPWi h3 {
    color: #666;
    margin-bottom: 12px;
    font-size: 14px;
  }
  
  .DashboardPage_referralStat__JZPWi p {
    font-size: 24px;
    font-weight: 600;
  }
  
  @media (max-width: 768px) {
    .DashboardPage_container__JcdmW {
      padding: 20px;
    }
  
  
    .DashboardPage_statsGrid__wLNk7 {
      grid-template-columns: 1fr;
    }
  
    .DashboardPage_referralStats__Q7rlg {
      grid-template-columns: 1fr;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/dappPages/DashboardPage/DashboardPage.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA,qBAAqB;EACrB;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE;MACE,aAAa;IACf;;;IAGA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;EACF","sourcesContent":[".earnPage {\n    min-height: 100vh;\n    background-color: #040404;\n    color: #ffffff;\n  }\n  \n  .container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 40px 20px;\n  }\n  \n  /* Dashboard Styles */\n  .dashboardSection {\n    background: #1a1a1a;\n    border-radius: 12px;\n    padding: 32px;\n    margin-bottom: 40px;\n    text-align: left;\n  }\n  \n  .statsGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 24px;\n    margin-bottom: 40px;\n  }\n  \n  .statCard {\n    background: #2a2a2a;\n    padding: 24px;\n    border-radius: 8px;\n    text-align: center;\n  }\n  \n  .statCard h3 {\n    color: #666;\n    margin-bottom: 12px;\n    font-size: 14px;\n  }\n  \n  .statValue {\n    font-size: 24px;\n    font-weight: 600;\n  }\n  \n  .activityFeed {\n    background: #2a2a2a;\n    padding: 24px;\n    border-radius: 8px;\n  }\n  \n  .activityFeed h3 {\n    margin-bottom: 20px;\n    color: #ffffff;\n  }\n  \n  .noActivity {\n    color: #666;\n    text-align: center;\n    padding: 20px;\n  }\n  \n  /* Tabs Section */\n  .tabsSection {\n    border-radius: 12px;\n    overflow: hidden;\n  }\n  \n  .tabs {\n    display: flex;\n    border-bottom: 1px solid #2a2a2a;\n  }\n  \n  .tab {\n    padding: 12px 24px;\n    background: none;\n    border: none;\n    color: #666;\n    font-size: 16px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-bottom: 2px solid transparent;\n  }\n  \n  .tab:hover {\n    color: #ffffff;\n  }\n  \n  .tab.active {\n    color: #ffffff;\n    border-bottom-color: #ffffff;\n    background: none;\n  }\n  \n  .content {\n    padding-top: 16px;\n  }\n  \n  /* Referral Styles */\n  .referralCard {\n    background: #2a2a2a;\n    padding: 24px;\n    border-radius: 8px;\n    margin-bottom: 24px;\n  }\n  \n  .referralInfo {\n    margin-bottom: 20px;\n    color: #666;\n  }\n  \n  .referralLinkBox {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 12px;\n  }\n  \n  .referralInput {\n    flex: 1;\n    padding: 12px 16px;\n    background: #1a1a1a;\n    border: 1px solid #333;\n    border-radius: 4px;\n    color: #ffffff;\n    font-family: monospace;\n    font-size: 14px;\n  }\n  \n  .referralInput:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  .copyButton {\n    padding: 0 24px;\n    background: #ffffff;\n    color: #000000;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: all 0.3s ease;\n  }\n  \n  .copyButton:hover:not(:disabled) {\n    opacity: 0.9;\n  }\n  \n  .copyButton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  .copyButton.copied {\n    background: #4CAF50;\n    color: #ffffff;\n  }\n  \n  .warning {\n    color: #ff4444;\n    font-size: 14px;\n    margin-top: 12px;\n    text-align: center;\n  }\n  \n  .referralStats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 24px;\n  }\n  \n  .referralStat {\n    background: #2a2a2a;\n    padding: 24px;\n    border-radius: 8px;\n    text-align: center;\n  }\n  \n  .referralStat h3 {\n    color: #666;\n    margin-bottom: 12px;\n    font-size: 14px;\n  }\n  \n  .referralStat p {\n    font-size: 24px;\n    font-weight: 600;\n  }\n  \n  @media (max-width: 768px) {\n    .container {\n      padding: 20px;\n    }\n  \n  \n    .statsGrid {\n      grid-template-columns: 1fr;\n    }\n  \n    .referralStats {\n      grid-template-columns: 1fr;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"earnPage": `DashboardPage_earnPage__vIIYf`,
	"container": `DashboardPage_container__JcdmW`,
	"dashboardSection": `DashboardPage_dashboardSection__wdmsQ`,
	"statsGrid": `DashboardPage_statsGrid__wLNk7`,
	"statCard": `DashboardPage_statCard__3jzJo`,
	"statValue": `DashboardPage_statValue__draDP`,
	"activityFeed": `DashboardPage_activityFeed__u1p8U`,
	"noActivity": `DashboardPage_noActivity__1CcN1`,
	"tabsSection": `DashboardPage_tabsSection__TXd40`,
	"tabs": `DashboardPage_tabs__EzM93`,
	"tab": `DashboardPage_tab__3COSE`,
	"active": `DashboardPage_active__wCWNZ`,
	"content": `DashboardPage_content__dx8HA`,
	"referralCard": `DashboardPage_referralCard__PppD9`,
	"referralInfo": `DashboardPage_referralInfo__zubs5`,
	"referralLinkBox": `DashboardPage_referralLinkBox__oMCMm`,
	"referralInput": `DashboardPage_referralInput__8ldZu`,
	"copyButton": `DashboardPage_copyButton__rsF2d`,
	"copied": `DashboardPage_copied__uGb0o`,
	"warning": `DashboardPage_warning__-QjE2`,
	"referralStats": `DashboardPage_referralStats__Q7rlg`,
	"referralStat": `DashboardPage_referralStat__JZPWi`
};
export default ___CSS_LOADER_EXPORT___;
